import _ from 'lodash'
import Typography from '../../../../../../components/Typography/Typography'
import { AXIS_SEAT_OFFSET, TOP_OFFSET } from '../../constants'

import './GridAxes.scss'

const GridAxes = ({ data, scaleFactor, maxSeatingChildrenX }) => {
    if (_.isEmpty(data)) return null

    return (
        <>
            {data?.map((axis, indx) => {
                const axisY = axis?.y1
                const axisX = axis?.x1

                if (axis?.type !== 'CAPTION') return null

                const top = axisY * scaleFactor + TOP_OFFSET + AXIS_SEAT_OFFSET
                const left = axisX >= maxSeatingChildrenX - 1 ? axisX * scaleFactor + 24 : axisX * scaleFactor

                return (
                    <Typography
                        key={`axis-caption-${axis?.text}-${indx}`}
                        className={'axis-caption'}
                        style={{ top: `${top}px`, left: `${left}px` }}
                    >
                        {axis?.text}
                    </Typography>
                )
            })}
        </>
    )
}

export default GridAxes
